{
  "iconStyle": {
    "alignment": "Ausrichtung",
    "screen": "Bildschirm ausgerichtet",
    "north": "Nach Norden ausgerichtet"
  },
  "mapObjectSelectionHelpers": {
    "layerNotVisible": {
      "message": "Das ausgewählte Kartenobjekt befindet sich auf einer visuell verborgenen Ebene",
      "cta": "Sichtbarkeit ein- und ausschalten"
    },
    "objectOnDifferentLevel": {
      "message": "Das ausgewählte Kartenobjekt befindet sich auf einer anderen Ebene",
      "cta": "Ebene wechseln"
    },
    "layerNotVisibleAndObjectOnDifferentLevel": {
      "message": "Das gewählte Kartenobjekt befindet sich auf einer visuell verborgenen Ebene und auf einer anderen Ebene",
      "cta": "Schaltet die Sichtbarkeit um und wechselt die Ebene"
    }
  },
  "dates": {
    "objectDetails": {
      "noRangesAvailable": "Keine Reichweiten",
      "rangeAvailable": "1 Bereich",
      "rangesAvailable": "{{ rangesAmount }} Bereiche",
      "add": "Datums- und Zeitbereiche hinzufügen",
      "noDataAvailable": "Keine Daten verfügbar"
    },
    "dateRangeAttribute": {
      "name": "Name",
      "dates": "Termine",
      "time": "Uhrzeit"
    },
    "startDate": "Datum des Beginns",
    "attributeName": "Datums- und Zeitbereich (z. B. Schichten)",
    "attributeInfoBox": {
      "title": "Beispiel für Datenwerte",
      "infoBlurb": "Verwenden Sie dieses Attribut, um den Datums- und Uhrzeitbereich zu definieren, zu dem das Kartenobjekt sichtbar sein soll. Beispielsweise wird „<strong>Johns Frühschicht</strong>“ zwischen <strong>9:45 Uhr und <strong>17:45</strong> Uhr</strong> angezeigt. Diese Sichtbarkeit kann auch durch die Auswahl im Datums- und Zeitbereich der Karte unten rechts auf der Karte bestimmt werden.",
      "johnsMorningShift": "Johns Frühschicht"
    },
    "attributeSettings": "Attributeinstellungen",
    "addRange": "Bereich hinzufügen",
    "mapObjectDateFiltered": "Das ausgewählte Kartenobjekt wird nach dem ausgewählten Datum gefiltert",
    "mapObjectDateFilteredCta": "Entfernen Sie den Datumsfilter",
    "tooltip": {
      "title": "Wiederkehrender Datums- und Zeitbereich",
      "blurb": "Verwenden Sie diese Funktion, um sich wiederholende Bereiche für ein bestimmtes Ereignis an regelmäßig wiederkehrenden Terminen festzulegen. Z. B. Schichten von Mitarbeitern"
    },
    "calendarTooltip": "Kartenfilter für Datum und Uhrzeit"
  },
  "ranges": "reicht",
  "digitalTwin": {
    "loading": {
      "header": "Erstellen Sie Ihren digitalen Zwilling",
      "message": "Dies kann einen Moment dauern"
    },
    "restarting": {
      "header": "Hoppla!",
      "message": "Entschuldigung, etwas ist schief gelaufen. Wir stellen die Verbindung zum digitalen Zwilling wieder her..."
    }
  },
  "styles": {
    "arrows": {
      "sameAsLine": "Das Gleiche wie Line",
      "custom": "Benutzerdefiniert"
    },
    "customImage": "Benutzerdefiniertes Bild",
    "customColour": "Benutzerdefinierte Farbe",
    "selectImage": "Wählen Sie ein benutzerdefiniertes Bild",
    "customImagePerModel": "Sie können nur 1 Bild pro Modell hochladen. Sie können Ihre Auswahl unten ersetzen.",
    "customImageAspectRatio": "Dieses Bild hat nicht das angegebene Seitenverhältnis von {{ aspectRatio }} Es kann gestreckt oder gequetscht erscheinen."
  },
  "moveLayer": {
    "front": "Nach vorne bringen",
    "back": "Nach hinten schicken"
  },
  "controls": {
    "user_location": "Standort des Benutzers"
  },
  "deleteAttributePrompt": {
    "title": "Möchten Sie dieses Attribut wirklich löschen?",
    "message": "Dadurch werden die Attributdaten von allen Objekten in dieser Ebene dauerhaft entfernt. Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "fileUpload": {
    "image_comment": "Bild zum Kommentieren hochladen",
    "invalid": "Die Datei, die Sie hochgeladen haben, ist ungültig. Bitte laden Sie eine gültige PNG-, JPG- oder JPEG-Datei hoch"
  },
  "comments": {
    "edit": "Kommentar bearbeiten",
    "delete": "Kommentar löschen",
    "image": "Bild hinzufügen",
    "replaceImage": "Bild ersetzen"
  },
  "upload_asset": {
    "icon": "Symbol",
    "model": "3D-Modell",
    "upload_model": "Laden Sie ein 3D-Modell hoch",
    "update_model": "3D-Modell aktualisieren",
    "upload_icon": "Laden Sie ein Symbol hoch",
    "update_icon": "Symbol bearbeiten",
    "name": "Name von {{ assetType }}",
    "categories": "Kategorien",
    "search_for_categories": "Suche nach Kategorien",
    "select_asset": "Wählen Sie {{ assetType }}",
    "select_file": "Wählen Sie eine Datei",
    "file_end": "Die Datei muss enden in",
    "or": "oder",
    "not_support_custom_image": "Das Modell, das Sie hochgeladen haben, unterstützt keine benutzerdefinierten Bilder. Um zu erfahren, wie Sie dies aktivieren können, lesen Sie den Artikel ",
    "select_thumbnail": "Vorschaubild",
    "something_went_wrong": "Etwas ist schief gelaufen",
    "image_size": "Größe des Bildes",
    "image_style": "Stil des Bildes",
    "image_file": "Bilddatei",
    "enable_colour_customisation": "Aktivieren Sie die Farbanpassung"
  },
  "permissionTooltip": "Sie haben keine Erlaubnis dazu ",
  "createLayerOptions": "Ebenenoptionen erstellen",
  "cancelDrawing": "Zeichnung abbrechen",
  "deleteObject": "Objekt löschen",
  "importNoWebSocketsToast": "Die Ebene (n) wurde (n) importiert/kopiert. Aktualisieren Sie, um die Ebenen zu sehen",
  "refresh": "Aktualisieren"
}